import { render, staticRenderFns } from "./scancodedetail.vue?vue&type=template&id=9cfb4652&scoped=true&"
import script from "./scancodedetail.vue?vue&type=script&lang=js&"
export * from "./scancodedetail.vue?vue&type=script&lang=js&"
import style0 from "./scancodedetail.vue?vue&type=style&index=0&id=9cfb4652&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9cfb4652",
  null
  
)

export default component.exports